import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Snackbar.scss'

type SnackbarProps = {
  active?: boolean
  level?: 'success' | 'info' | 'warn' | 'danger'
  message?: string
  position?: string
  onDismiss?(...args: unknown[]): unknown
  onTrigger?(...args: unknown[]): unknown
  trigger?: {
    text?: string
    color?: string
  }
}

class Snackbar extends React.PureComponent<SnackbarProps> {
  render() {
    const { active, position, level, message, trigger, onDismiss, onTrigger } = this.props
    let cname = 'Snackbar-root'
    if (level) cname += ` ${level}`
    if (position) cname += ` ${position}`
    if (active) cname += ' active'
    const hasTrigger = trigger && trigger.text
    return (
      <div className={cname}>
        <div className="Snackbar-main">
          <div className="Snackbar-message">{message}</div>
          {hasTrigger && (
            <div className="Snackbar-trigger" onClick={onTrigger}>
              {trigger.text}
            </div>
          )}
          {onDismiss && (
            <div className="Snackbar-dismiss" onClick={onDismiss}>
              <FontAwesomeIcon icon="times" />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Snackbar
